// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"da3bad08","306":"732de542","671":"13041b6f","716":"55b5af6a","780":"3eb57bf1"}[chunkId] + ".chunk.css";
};